"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _BuySellOrderOverviewComponent = _interopRequireDefault(require("./BuySellOrderOverviewComponent"));
var _instrumentPositionSelectors = require("../../../../redux/selectors/instrumentPositionSelectors");
var _buySellSelectors = require("../../../../redux/selectors/buySellSelectors");
var _productPositionSelectors = require("../../../../redux/selectors/productPositionSelectors.js");
var _numberFormatter = require("../../../../helpers/numberFormatter");
var _orderHelper = require("../../../../helpers/orderHelper.js");
var _config = _interopRequireDefault(require("../../../../config"));
var _decimalPlacesHelper = require("../../../../helpers/decimalPlaces/decimalPlacesHelper");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state) {
  var buySellForm = state.form.buySell || {
    values: {
      fee: {}
    }
  };
  var selectedValue = (0, _buySellSelectors.getOrderFormInfoSelector)(state);
  var isBuySide = (0, _buySellSelectors.isBuySideBuySellFormSelector)(state);
  var _selectedInstrumentSe = (0, _instrumentPositionSelectors.selectedInstrumentSelector)(state),
    Product1Symbol = _selectedInstrumentSe.Product1Symbol,
    Product2Symbol = _selectedInstrumentSe.Product2Symbol,
    QuantityIncrement = _selectedInstrumentSe.QuantityIncrement,
    PriceIncrement = _selectedInstrumentSe.PriceIncrement;
  var quantity = selectedValue.quantity || 0;
  var transactionCost = selectedValue.price || 0;
  var limitPrice = selectedValue.limitPrice || 0;
  var pricePerUnit = selectedValue.pricePerUnit ? selectedValue.pricePerUnit : 0;
  var products = (0, _productPositionSelectors.productsSelector)(state);
  return {
    symbol1: Product1Symbol,
    symbol2: Product2Symbol,
    isBuySide: isBuySide,
    fee: (0, _orderHelper.getOrderFee)(buySellForm.values, products, 'end'),
    price: (0, _numberFormatter.formatNumberToLocale)(limitPrice, (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(PriceIncrement)),
    tradingDisabled: (0, _buySellSelectors.tradingDisabledSelector)(state),
    transactionCost: (0, _numberFormatter.formatNumberToLocale)(transactionCost, (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(PriceIncrement)),
    quantity: (0, _numberFormatter.formatNumberToLocale)(quantity.toString(), (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(QuantityIncrement)),
    pricePerUnit: (0, _orderHelper.getOrderPricePerUnit)(pricePerUnit, Product1Symbol, (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(PriceIncrement)),
    hideFees: !!_config["default"].global.hideFees
  };
};
var BuySellOrderOverviewContainer = (0, _reactRedux.connect)(mapStateToProps)(_BuySellOrderOverviewComponent["default"]);
var _default = exports["default"] = BuySellOrderOverviewContainer;